import { VTab, VueTabs } from 'vue-nav-tabs'
import AdminCoursesTab from './courses-tab/courses-tab.vue'
import AdminCourseTypes from './course-types/course-types.vue'
import AdminCoupons from '@/components/admin/coupons/coupons.vue'

import 'vue-nav-tabs/themes/vue-tabs.scss'

export default {
    name: 'AdminCourses',
    components: {
        VueTabs,
        VTab,
        AdminCoursesTab,
        AdminCourseTypes,
        AdminCoupons
    },
    data() {
        return {}
    },
    methods: {
       
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/courses/courses.js